export const formData1 = [
  {
    name: 'real_name',
    lable: '姓名',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'phone',
    lable: '联系方式',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'id',
    lable: '账号',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'provinceCity',
    lable: '所在省市',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'qichacha_name',
    lable: '所属单位',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'address',
    lable: '联系地址',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
];
export const formData2 = [
  {
    name: 'pwd_old',
    lable: '旧密码',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'pwd_new',
    lable: '新密码',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'pwd_new1',
    lable: '确认密码',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
];
